import trekronorTheme from "../../trekronorTheme";
export default {
  ...trekronorTheme,
  colors: {
    ...trekronorTheme.colors,
    quinary1: trekronorTheme.colors.primary1,
    quinary2: trekronorTheme.colors.primary5,
    quinary3: trekronorTheme.colors.primary6,
    senary1: trekronorTheme.colors.white,
    primary4: trekronorTheme.colors.primary6
  },
  borderRadius: {
    ...trekronorTheme.borderRadius,
    full: 0
  }
};
